<template>
	<base-button @click="handleClick()" class="btn btn-primary btn-sm">Edit</base-button>
</template>

<script>
export default {
	// props: ['params'],
	methods: {
		handleClick() {
			const rowData = this.params.data;
			// alert(`Row Data: ${JSON.stringify(rowData)}`);

			//_ parent data and that is INVERTER, how can we get this parent info ? from CONTEXT params that can be access by selected child data (STRING)
			let dataInverter = this.params.context.params.data;
			
			//_ selected STRING data
			let dataString = this.params.data;

			//_ emit / execute parent component method and also send the value 
			this.params.actionEdit(dataInverter, dataString);
		},
	},
};
</script>